// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-error-reload-contents-button[data-v-7ad27216]{width:78px;margin:25px 0}.c-error-reload-contents[data-v-7ad27216] .m-heading-primary{font-size:1.4rem}", ""]);
// Exports
module.exports = exports;
